import React from "react";
import Preloader from "../../../common/preLoader/PreLoader";
import PortalPreloader from "./PortalPreloader";

/**
 * Choisit l'écran de chargement selon l'espace affiché.
 *
 * `ZorniProvider` et `PersonProvider` enveloppent toute l'application, back-office
 * compris : sans cette bascule, refaire le preloader du portail changerait aussi
 * celui de l'administration, qui n'est pas dans le périmètre de la refonte.
 *
 * Le chemin est lu sur `window` et non via `useLocation` : ces deux fournisseurs
 * sont montés au-dessus du routeur, le contexte n'existe pas encore.
 */
const isAdmin = () =>
  typeof window !== "undefined" &&
  window.location?.pathname?.startsWith("/admin");

export const AppPreloader = () => (isAdmin() ? <Preloader /> : <PortalPreloader />);

export default AppPreloader;
